import React from 'react';
import { AdaptiveModal } from './AdaptiveModal';
import { PomodoroTimer } from './PomodoroTimer';
import { Todo } from '../types';

interface PomodoroModalProps {
  isOpen: boolean;
  onClose: () => void;
  task: Todo | null;
  selectedTeamId?: string | null;
  onTaskComplete?: (task: Todo) => void;
}

export const PomodoroModal: React.FC<PomodoroModalProps> = ({
  isOpen,
  onClose,
  task,
  selectedTeamId,
  onTaskComplete
}) => {
  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={onClose}
      title=""
      size="md"
    >
      <div className="p-4">
        {task && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <span className="font-medium">Working on:</span> {task.title}
            </p>
          </div>
        )}
        
        <PomodoroTimer
          isCompact={false}
          selectedTeamId={selectedTeamId}
        />
        
        {task && onTaskComplete && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <button
              onClick={() => onTaskComplete(task)}
              className="w-full px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
            >
              Mark Task Complete
            </button>
          </div>
        )}
      </div>
    </AdaptiveModal>
  );
};